import gql, { disableFragmentWarnings } from 'graphql-tag';

import VendorConfigFragment from './vendor-config';

disableFragmentWarnings();

export default gql`
  fragment VendorConfigsFragment on VendorConfigs {
    sicom {
      ...VendorConfigFragment
    }
    sicomDelivery {
      ...VendorConfigFragment
    }
    ncr {
      ...VendorConfigFragment
    }
    ncrDelivery {
      ...VendorConfigFragment
    }
    carrols {
      ...VendorConfigFragment
    }
    carrolsDelivery {
      ...VendorConfigFragment
    }
    oheics {
      ...VendorConfigFragment
    }
    oheicsDelivery {
      ...VendorConfigFragment
    }
    partner {
      ...VendorConfigFragment
    }
    partnerDelivery {
      ...VendorConfigFragment
    }
    qdi {
      ...VendorConfigFragment
    }
    qdiDelivery {
      ...VendorConfigFragment
    }
    qst {
      ...VendorConfigFragment
    }
    qstDelivery {
      ...VendorConfigFragment
    }
    rpos {
      ...VendorConfigFragment
    }
    rposDelivery {
      ...VendorConfigFragment
    }
    simplyDelivery {
      ...VendorConfigFragment
    }
    simplyDeliveryDelivery {
      ...VendorConfigFragment
    }
    tablet {
      ...VendorConfigFragment
    }
    tabletDelivery {
      ...VendorConfigFragment
    }
    productNumber {
      ...VendorConfigFragment
    }
  }

  ${VendorConfigFragment}
`;
